<template>
  <div class="action-config-item">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <el-select
      v-if="localStep.action == 'other/ADD'"
      v-model="localStep.entity_from"
      placeholder="Select entity"
      @change="(changedValue) => setEntityFromDetails(changedValue)"
      clearable
      filterable
    >
      <el-option-group label="Relational"></el-option-group>
      <el-option-group label="Other entities">
        <el-option
          v-for="(entity, index) of filteredEntities"
          :value="'other/' + entity._id"
          :key="index"
          :label="entity.name"
        >
          <span style="float: left">{{ entity.name }}</span>
        </el-option>
      </el-option-group>
    </el-select>
    <el-select
      v-if="localStep.action == 'other/AUTOMATE'"
      v-model="localStep.entity_from"
      placeholder="Select entity"
      @change="(changedValue) => setEntityFromDetails(changedValue)"
      clearable
      filterable
    >
      <el-option-group label="Other entities">
        <el-option
          v-for="(entity, index) of filteredEntities"
          :value="'other/' + entity._id"
          :key="index"
          :label="entity.name"
        >
          <span style="float: left">{{ entity.name }}</span>
        </el-option>
      </el-option-group>
    </el-select>
    <el-button
      @click="openPrimaryFieldsModal()"
      v-if="localStep.entity_from && localStep.action == 'other/ADD'"
      icon="el-icon-s-tools"
    >
      Configure
    </el-button>
    <el-button
      @click="openPrimaryFieldsModal(localStep)"
      v-if="localStep.entity_from && localStep.action == 'other/AUTOMATE'"
      icon="el-icon-s-tools"
      size="mini"
    >
      Mapping
    </el-button>
    <el-tooltip
      v-if="
        localStep.entity_from && localStep.action == 'other/ADD' && IsDataTableSelected(localStep)
      "
      class="item"
      effect="dark"
      content="Data table fields are selected so from where new data has to be created?"
      placement="top-start"
    >
      <el-radio-group v-model="localStep.take_data_from">
        <el-radio label="original_data">Original data</el-radio>
        <el-radio label="selected_data">Selected data</el-radio>
        <el-radio label="total_data">Total data</el-radio>
      </el-radio-group>
    </el-tooltip>
    <div class="d-flex">
      <el-tooltip
        v-if="
          localStep.entity_from &&
          localStep.action == 'other/ADD' &&
          IsDataTableSelected(localStep) &&
          localStep.take_data_from == 'selected_data'
        "
        class="item"
        effect="dark"
        content="Not include splitted data"
        placement="top-start"
      >
        <el-checkbox
          class="mt-1"
          v-if="
            localStep.entity_from &&
            localStep.action == 'other/ADD' &&
            IsDataTableSelected() &&
            localStep.take_data_from == 'selected_data'
          "
          v-model="localStep.allow_original"
        ></el-checkbox>
      </el-tooltip>
      <el-tooltip
        v-if="
          localStep.entity_from &&
          localStep.action == 'other/ADD' &&
          trigger &&
          trigger.when == 'ADDED'
        "
        class="item"
        effect="dark"
        content="Delete added child data if parent is deleted"
        placement="top-start"
      >
        <el-checkbox
          class="mt-1"
          v-if="localStep.entity_from && localStep.action == 'other/ADD'"
          v-model="localStep.delete_child_data"
        ></el-checkbox>
      </el-tooltip>
    </div>
    <div class="d-flex">
      <el-tooltip
        v-if="localStep.entity_from && localStep.action == 'other/ADD'"
        class="item"
        effect="dark"
        content="Update existed data with condition"
        placement="top-start"
      >
        <el-select
          v-model="localStep.update_filter_id"
          placeholder="Update with condition"
          clearable
          filterable
        >
          <el-option
            v-for="filter in allEntityFilters[localStep.entity_id] || []"
            :key="filter._id"
            :label="filter.filter_name"
            :value="filter._id"
          >
            {{ filter.filter_name }}
          </el-option>
        </el-select>
      </el-tooltip>
    </div>
    <div>
      <el-tooltip
        v-if="
          localStep.entity_from && localStep.action == 'other/ADD' && localStep.update_filter_id
        "
        class="item"
        effect="dark"
        content="Allow Create new data if existed data not found"
        placement="top-start"
      >
        <el-checkbox
          class="mt-1"
          v-model="localStep.create_new_data"
          v-if="
            localStep.entity_from && localStep.update_filter_id && localStep.action == 'other/ADD'
          "
        ></el-checkbox>
      </el-tooltip>
    </div>
    <div
      v-if="
        localStep.entity_from && IsDataTableSelected(localStep) && localStep.action == 'other/ADD'
      "
    >
      <el-badge
        class="badge"
        type="warning"
        :value="
          localStep && localStep.data_table_filters && localStep.data_table_filters.length
            ? localStep.data_table_filters.length
            : 0
        "
      >
        <el-button
          icon="el-icon-plus"
          class="mt-1"
          size="mini"
          :underline="false"
          @click="addDataFilter(localStep)"
        >
          Add data table filter
        </el-button>
      </el-badge>
    </div>
    <!-- Footer Actions -->
    <div class="automation-footer-actions mt-4 flex justify-end gap-2">
      <el-button @click="cancelChanges">Cancel</el-button>
      <el-button type="primary" @click="saveChanges">Save</el-button>
    </div>
    <!-- Mapping primary fields -->
    <dialog-component
      :visible="mapPrimaryFieldsModal"
      :title="'Map Entity Fields'"
      @before-close="resetPrimaryMapTemplate"
      :containerWidth="'75%'"
      :containerHeight="'80%'"
    >
      <div>
        <div style="text-align: left">
          <el-collapse accordion v-model="activeStep">
            <el-collapse-item
              v-for="(templateId, i) in actionEntityTemplates"
              :key="i + '_' + templateId"
              :name="i + 1"
              class="rule-collapse"
            >
              <template slot="title" style="border: 1px solid #e4e7ed">
                <div style="width: 100%" class="ml-1">
                  <label v-if="allTemplateFieldMap[templateId]">
                    <b>
                      {{ i + 1 }}.
                      {{ allTemplateFieldMap[templateId].name }}
                    </b>
                  </label>
                </div>
                <div>
                  <el-button @click.stop="openDataTableConfigDialog(templateId)">
                    Map Data Tables
                  </el-button>
                </div>
              </template>
              <!-- || e.type!= "CONTENT" -->
              <el-table
                v-if="allTemplateFieldMap[templateId]"
                :data="
                  allTemplateFieldMap[templateId].fields.filter((e) => e.input_type != 'FORMULA')
                "
                border
                class="scrollbar-content"
              >
                <el-table-column label="Field" prop="label" width="200"></el-table-column>
                <el-table-column label="Mapped with" prop="key" width="250">
                  <template slot-scope="scope">
                    <div class="d-flex">
                      <el-select
                        v-model="actionEntityPrimaryFieldsMap['mapped/' + scope.row.key]"
                        placeholder="Update with"
                        clearable
                        filterable
                        :disabled="
                          actionEntityPrimaryFieldsMap[scope.row.key] &&
                          actionEntityPrimaryFieldsMap[scope.row.key].length
                            ? true
                            : false
                        "
                      >
                        <el-option
                          v-for="(field, i) in fetchTemplateFieldsByType(
                            [scope.row.inputType],
                            allFieldsWithDataTable,
                            scope.row.entity_id,
                            scope.row.key
                          )"
                          :key="field + i"
                          :value="field.key"
                          :label="field.label"
                          :disabled="tableFieldDisabled(field)"
                        ></el-option>
                        <el-option
                          v-if="
                            scope.row.input_type == 'ENTITY' &&
                            scope.row.entity_id == currentEntity._id
                          "
                          :label="
                            'Current ' +
                            (currentEntity && currentEntity.name ? currentEntity.name : 'entity')
                          "
                          value="currentEntityData"
                        ></el-option>
                      </el-select>
                      <el-tooltip
                        v-if="
                          !actionEntityPrimaryFieldsMap[scope.row.key] &&
                          localStep &&
                          localStep.update_filter_id
                        "
                        class="item"
                        effect="dark"
                        content="Include in filter"
                        placement="top-start"
                        style="margin-top: 8px"
                      >
                        <el-checkbox
                          v-if="
                            !actionEntityPrimaryFieldsMap[scope.row.key] &&
                            localStep &&
                            localStep.update_filter_id
                          "
                          v-model="actionEntityPrimaryFieldsMap['filter/' + scope.row.key]"
                        ></el-checkbox>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Default value" prop="key" width="250">
                  <template slot-scope="scope">
                    <AnyFieldsExecute
                      v-if="actionEntityPrimaryFieldsMap['mapped/' + scope.row.key] ? false : true"
                      :fieldsData="allTemplateFieldMap[templateId].fields"
                      :field="
                        getFieldProperty(
                          allTemplateFieldMap[templateId].fields,
                          scope.row.key,
                          'key',
                          '',
                          {}
                        )
                      "
                      :form="actionEntityPrimaryFieldsMap"
                    ></AnyFieldsExecute>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Fill with relational data"
                  width="250"
                  v-if="fillWithRelationVisible"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-if="scope.row.input_type == 'ENTITY'"
                      v-model="actionEntityPrimaryFieldsMap['relation/' + scope.row.key]"
                      filterable
                      clearable
                      @change="rowValueChange(scope.row)"
                    >
                      <el-option
                        v-for="(rel, index) in getRelations(scope.row)"
                        :key="index"
                        :value="rel.key + '#' + rel.entity_id"
                        :label="rel.label"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="If existed found" prop="label">
                  <template slot-scope="scope">
                    <el-select
                      v-if="scope.row.inputType == 'NUMBER' || scope.row.inputType == 'CURRENCY'"
                      v-model="actionEntityFieldsOparatorMap[scope.row.key]"
                      placeholder="Operator"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="(field, i) in operators[scope.row.inputType]"
                        :key="field + i"
                        :value="field.key"
                        :label="field.label"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  label="If duplicate table rows found"
                  prop="label"
                  v-if="localStep && localStep.allow_original"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-if="
                        (scope.row.inputType == 'NUMBER' || scope.row.inputType == 'CURRENCY') &&
                        localStep &&
                        localStep.allow_original &&
                        scope.row.key.includes(':')
                      "
                      v-model="actionEntityFieldsOparationsMap[scope.row.key]"
                      placeholder="Operation"
                      clearable
                      filterable
                    >
                      <el-option value="SUM" label="Sum"></el-option>
                      <el-option value="AVERAGE" label="Average"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetPrimarymapTemplate">Close</el-button>
        <el-button type="primary" :disabled="checkSaveDisable" @click="savePrimaryMapTemplate">
          Save
        </el-button>
      </span>
    </dialog-component>
    <dialog-component
      :title="'Map Tables'"
      :visible="dataTableMappingConfig"
      :isShowFooter="false"
      :containerWidth="'52%'"
      @before-close="handleDataTableConfigClose()"
    >
      <div class="p-5">
        <template>
          <p>Selected Entity Data Tables</p>
          <el-table :data="selectedEntityTableFields" border style="width: 100%">
            <el-table-column prop="label" label="Data Table Field" width="200">
              <template slot-scope="scope">
                {{ scope.row.label }}
              </template>
            </el-table-column>
            <el-table-column label="Mapped with" prop="key" width="500">
              <template slot-scope="scope">
                <el-select
                  v-if="dataTableConfigObject && showDataTableConfigObject"
                  v-model="dataTableConfigObject[scope.row.key].selected_type"
                  placeholder="Map with"
                  @change="handleDataTableConfigObject()"
                  clearable
                >
                  <el-option
                    key="table_fields"
                    label="Map With Table Fields"
                    value="table_fields"
                  ></el-option>
                  <el-option
                    key="individual_fields"
                    label="Map With Individual Fields"
                    value="individual_fields"
                    :disabled="checkIsAlreadySelected()"
                  ></el-option>
                </el-select>
                <el-select
                  v-if="
                    dataTableConfigObject[scope.row.key]?.selected_type == 'table_fields' &&
                    showDataTableConfigObject
                  "
                  @change="handleDataTableConfigObject()"
                  v-model="dataTableConfigObject[scope.row.key].selected_data_table_key"
                >
                  <el-option
                    v-for="(field, i) in fetchTemplateFieldsByType(
                      [scope.row.inputType],
                      allCurrentEntityFields,
                      scope.row.entity_id,
                      scope.row.key
                    )"
                    :key="field + i"
                    :value="field.key"
                    :label="field.label"
                    :disabled="tableFieldDisabled(field)"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </dialog-component>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { getFieldProperty } from '../actionHelper';
  import templateBuilderHelper from '../../../../mixins/templateBuilderHelper';
  import StepEditableMixin from './StepEditableMixin';
  export default {
    name: 'OtherAddAction',
    props: {
      step: Object,
      allEntityFilters: Object,
      allEntities: Array,
      currentEntity: Object,
      allTemplates: Array,
      trigger: Object,
      templateFieldMap: Object,
      allTemplateFieldMap: Object,
      companyAllTemplateFields: Object,
    },
    data() {
      return {
        activeStep: 1,
        dataTableMappingConfig: false,
        allFieldsWithDataTable: [],
        actionEntityPrimaryFieldsMap: {},
        actionEntityFieldsOparatorMap: {},
        actionEntityFieldsOparationsMap: {},
        actionEntityPrimaryFields: [],
        actionEntityTemplates: [],
        dataTableConfigObject: null,
        showDataTableConfigObject: true,
        fillWithRelationVisible: false,
        selectedEntityTableFields: [],
        mapPrimaryFieldsModal: false,
      };
    },
    mixins: [StepEditableMixin, templateBuilderHelper],
    components: {
      AnyFieldsExecute: () =>
        import('@/components/templates/formComponentsExecute/AnyFieldsExecute.vue'),
    },
    mounted() {
      this.allFieldsWithDataTable = this.getAllFieldsFromEntity(
        this.currentEntity,
        true,
        true,
        true
      );
    },
    computed: {
      ...mapGetters('filters', ['getAllEntityFilters']),
      filteredEntities() {
        if (this.currentEntity?._id) {
          return this.allEntities.filter((e) => e._id != this.currentEntity._id);
        }
        return this.allEntities;
      },
      checkSaveDisable() {
        if (this.actionEntityPrimaryFieldsMap) {
          let emptyField = this.actionEntityPrimaryFields.find((e) => {
            if (
              !this.actionEntityPrimaryFieldsMap[e.key] &&
              !this.actionEntityPrimaryFieldsMap['mapped/' + e.key]
            ) {
              return e;
            }
          });
          if (emptyField) {
            return true;
          }
          return false;
        }
        return true;
      },
    },
    methods: {
      tableFieldDisabled(field) {
        if (
          field.data_table_field_index &&
          field.data_table_field_index > -1 &&
          Object.keys(this.actionEntityPrimaryFieldsMap).find((e) => e.includes('relation/')) !==
            undefined
        ) {
          return true;
        } else {
          return false;
        }
      },
      handleDataTableConfigObject() {
        this.showDataTableConfigObject = false;
        this.showDataTableConfigObject = true;
      },
      checkIsAlreadySelected() {
        let alreadySelected = false;
        Object.keys(this.dataTableConfigObject).map((key) => {
          if (this.dataTableConfigObject[key]?.selected_type == 'individual_fields') {
            alreadySelected = true;
          }
        });
        return alreadySelected;
      },
      IsDataTableSelected() {
        if (this.localStep?.primary_data) {
          let dataTableKey = Object.keys(this.localStep.primary_data).find(
            (e) =>
              e.includes('mapped/') &&
              this.localStep.primary_data[e] &&
              this.localStep.primary_data[e].includes(':')
          );
          return dataTableKey ? true : false;
        }
        return false;
      },
      async setEntityFromDetails(value) {
        if (value && value.includes('other/')) {
          this.$set(this.localStep, 'entity_id', value.replace('other/', ''));
          if (!this.allEntityFilters?.[this.localStep.entity_id]) {
            await this.$store.dispatch('filters/fetchAllEntityFilters', {
              entityId: this.localStep.entity_id,
            });
            if (this.getAllEntityFilters) {
              this.$set(this.allEntityFilters, this.localStep.entity_id, this.getAllEntityFilters);
            }
          }
          if (this.localStep.action == 'other/ADD') {
            this.openPrimaryFieldsModal(this.localStep);
            this.$set(this.localStep, 'create_new_data', true);
            this.$set(this.localStep, 'take_data_from', 'selected_data');
          }
        } else {
          this.$set(this.localStep, 'entity_id', '');
        }
      },

      async openPrimaryFieldsModal() {
        this.actionEntityPrimaryFieldsMap = {};
        this.actionEntityFieldsOparatorMap = {};
        this.actionEntityFieldsOparationsMap = {};
        this.actionEntityPrimaryFields = [];
        this.actionEntityTemplates = [];
        this.dataTableConfigObject = null;
        if (this.localStep?.primary_data) {
          this.actionEntityPrimaryFieldsMap = this.localStep.primary_data;
          if (this.localStep?.fields_operators) {
            this.actionEntityFieldsOparatorMap = this.localStep.fields_operators;
          }
          if (this.localStep?.fields_operations) {
            this.actionEntityFieldsOparationsMap = this.localStep.fields_operations;
          }
        }
        this.actionEntityPrimaryFields = getFieldProperty(
          this.allEntities,
          this.localStep.entity_id,
          '_id',
          'primaryFields',
          []
        );
        this.actionEntityTemplates = getFieldProperty(
          this.allEntities,
          this.localStep.entity_id,
          '_id',
          'templates',
          []
        ).flatMap((e) => e.template_id);
        if (this.localStep.action == 'other/AUTOMATE' || this.localStep.action == 'other/ADD') {
          let ids = this.allFieldsWithDataTable
            .filter((e) => e.input_type == 'ENTITY')
            .map((e) => e.entity_id);
          await this.$store.dispatch('entityRelationships/fetchMultipleEntityRelationships', {
            ids: ids,
          });
          this.fillWithRelationVisible = true;
        } else {
          this.fillWithRelationVisible = false;
        }
        this.actionEntityPrimaryFields = this.actionEntityPrimaryFields.map((e) => {
          if (e.key && !e.key.includes('#')) {
            e.key = e.template_id + '#' + e.key;
          }
          return e;
        });
        if (this.localStep.dataTableConfig) {
          this.dataTableConfigObject = this.localStep.dataTableConfig;
          let tempObj = {};

          (this.allTemplates || []).forEach((template) => {
            tempObj[template._id] = {
              name: template.name,
              id: template._id,
              fields: this.getFieldsFromTemplate(template, false, false),
            };
          });
          this.actionEntityTemplates.map((tempId) => {
            let fields = tempObj[tempId]?.fields?.filter((fd) => fd.inputType == 'DATA_TABLE');
            this.selectedEntityTableFields = [...this.selectedEntityTableFields, ...fields];
          });
        } else {
          this.prepareDataTableConfigObject();
        }
        this.mapPrimaryFieldsModal = true;
      },
      savePrimaryMapTemplate() {
        this.$set(this.localStep, 'primary_data', this.actionEntityPrimaryFieldsMap);
        this.$set(this.localStep, 'fields_operators', this.actionEntityFieldsOparatorMap);
        this.$set(this.localStep, 'fields_operations', this.actionEntityFieldsOparationsMap);
        this.$set(this.localStep, 'dataTableConfig', this.dataTableConfigObject);
        this.resetPrimaryMapTemplate();
      },
      resetPrimaryMapTemplate() {
        if (this.checkSaveDisable) {
          this.$set(this.localStep, 'entity_from', '');
          this.$set(this.localStep, 'entity_id', '');
        }
        this.actionEntityPrimaryFieldsMap = {};
        this.actionEntityFieldsOparatorMap = {};
        this.actionEntityFieldsOparationsMap = {};
        this.actionEntityPrimaryFields = [];
        this.actionEntityTemplates = [];
        this.mapPrimaryFieldsModal = false;
        this.actionEntityPrimaryFieldsMap = {};
        this.dataTableConfigObject = null;
      },
      openDataTableConfigDialog() {
        this.dataTableMappingConfig = true;
      },
      handleDataTableConfigClose() {
        this.dataTableMappingConfig = false;
      },
      rowValueChange(row) {
        if (this.actionEntityPrimaryFieldsMap['relation/' + row.key] == '') {
          delete this.actionEntityPrimaryFieldsMap['relation/' + row.key];
        } else {
          Object.keys(this.actionEntityPrimaryFields).map((e) => {
            if (e.includes('relation/') && e !== 'relation/' + row.key) {
              delete this.actionEntityPrimaryFieldsMap[e];
            }
          });
        }
      },
    },
  };
</script>
<style scoped>
  .action-config-item {
    background-color: #f9fafb; /* soft neutral background */
    border: 1px solid #e5e7eb; /* subtle border */
    border-radius: 8px;
    padding: 1rem;
    font-family:
      'Inter',
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      'Helvetica Neue',
      Arial,
      sans-serif;
    color: #374151; /* neutral gray text */
    transition: all 0.2s ease;
  }

  .action-config-item .el-select,
  .action-config-item .el-button,
  .action-config-item .el-checkbox,
  .action-config-item .el-radio {
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
  }

  .action-config-item .el-button {
    border-radius: 6px;
    background-color: #2563eb;
    color: white;
    font-weight: 500;
    padding: 0.35rem 0.75rem;
  }

  .action-config-item .el-button:hover {
    background-color: #1d4ed8;
  }

  .action-config-item .el-badge {
    margin-top: 0.5rem;
  }

  .action-config-item .d-flex {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
  }

  .action-config-item .el-tooltip .item {
    font-size: 0.85rem;
  }

  .dialog-footer .el-button {
    border-radius: 6px;
    padding: 0.35rem 0.75rem;
  }

  .dialog-footer .el-button[type='primary'] {
    background-color: #2563eb;
    color: #fff;
  }

  .dialog-footer .el-button[type='primary']:hover {
    background-color: #1d4ed8;
  }

  .scrollbar-content {
    max-height: 300px;
    overflow-y: auto;
  }

  .rule-collapse {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    margin-bottom: 0.5rem;
    background-color: #ffffff;
  }

  .el-table th,
  .el-table td {
    font-size: 0.9rem;
    color: #374151;
  }

  .el-table th {
    background-color: #f3f4f6;
  }
</style>
